/**
 * Shared SVG line-art icon component — replaces colour emojis app-wide.
 * Usage: <Icon name="phone" size={14} stroke="#6B7280" />
 */

const PATHS = {
  // People & Identity
  user:        ["M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2", "circle:12,7,4"],
  users:       ["M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2", "circle:9,7,4", "M23 21v-2a4 4 0 00-3-3.87", "M16 3.13a4 4 0 010 7.75"],

  // Communication
  phone:       ["M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"],
  message:     ["M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"],
  mail:        ["M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z", "M22 6l-10 7L2 6"],

  // Location
  mapPin:      ["M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z", "circle:12,10,3"],
  navigation:  ["M3 11l19-9-9 19-2-8-8-2z"],

  // Transport
  car:         ["M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v9a2 2 0 01-2 2h-2", "circle:7,17,2", "circle:17,17,2"],
  // Fuel pump. The car card states the fuel type as a fact beside the seats and
  // the year, and every other fact there has a glyph; this was the one reading as
  // bare text.
  fuel:        ["M3 22h12", "M4 9h10", "M14 22V4a2 2 0 00-2-2H6a2 2 0 00-2 2v18", "M14 13h2a2 2 0 012 2v2a2 2 0 004 0V9.83a2 2 0 00-.59-1.42L18 5"],
  // Globe. Same shape the header's language control uses, so "Speaks Telugu" on a
  // car card and the language picker read as the same idea.
  globe:       ["circle:12,12,10", "M2 12h20", "M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10Z"],
  truck:       ["M1 3h15v13H1z", "M16 8h4l3 3v5h-7V8z", "circle:5.5,18.5,2.5", "circle:18.5,18.5,2.5"],
  taxi:        ["M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z", "M14 2v6h6"],

  // Time & Calendar
  clock:       ["circle:12,12,10", "M12 6v6l4 2"],
  calendar:    ["M3 3h18v18H3z", "M3 9h18", "M8 1v4", "M16 1v4"],
  calendarDays:["rect:3,4,18,18,2", "M16 2v4", "M8 2v4", "M3 10h18"],

  // Files & Docs
  fileText:    ["M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z", "M14 2v6h6", "M16 13H8", "M16 17H8", "M10 9H8"],
  file:        ["M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z", "M13 2v7h7"],
  clipboard:   ["M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2", "M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1z"],
  id:          ["M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z", "M16 11h2", "M16 14h2", "M6 11h6", "M6 14h4"],

  // Finance
  rupee:       ["M6 3h12", "M6 8h12", "M6 13l8 8", "M6 8c0 2.4 1.8 4 4 4"],
  dollar:      ["M12 1v22", "M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"],
  wallet:      ["M20 12V22H4V12", "M22 7H2v5h20V7z", "M12 7V3", "M8 3h8"],

  // Status / Actions
  flag:        ["M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", "M4 22v-7"],
  check:       ["M20 6L9 17l-5-5"],
  checkCircle: ["circle:12,12,10", "M9 12l2 2 4-4"],
  x:           ["M18 6L6 18", "M6 6l12 12"],
  xCircle:     ["circle:12,12,10", "M15 9l-6 6", "M9 9l6 6"],
  alertTri:    ["M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z", "M12 9v4", "M12 17h.01"],
  alertCircle: ["circle:12,12,10", "M12 8v4", "M12 16h.01"],
  info:        ["circle:12,12,10", "M12 8v4", "M12 16h.01"],

  // Navigation actions
  refresh:     ["M23 4v6h-6", "M1 20v-6h6", "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"],
  upload:      ["M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4", "M17 8l-5-5-5 5", "M12 3v12"],
  download:    ["M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4", "M7 10l5 5 5-5", "M12 15V3"],
  edit:        ["M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7", "M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"],
  trash:       ["M3 6h18", "M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"],
  search:      ["circle:11,11,8", "M21 21l-4.35-4.35"],
  mic:         ["M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3z", "M19 10v2a7 7 0 01-14 0v-2", "M12 19v3"],
  settings:    ["circle:12,12,3", "M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"],
  plus:        ["M12 5v14", "M5 12h14"],
  filter:      ["M22 3H2l8 9.46V19l4 2v-8.54L22 3z"],
  eye:         ["M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z", "circle:12,12,3"],
  eyeOff:      ["M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24", "M1 1l22 22"],
  lock:        ["M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2z", "M7 11V7a5 5 0 0110 0v4"],
  unlock:      ["M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2z", "M7 11V7a5 5 0 019.9-1"],
  bell:        ["M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9", "M13.73 21a2 2 0 01-3.46 0"],
  star:        ["M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"],
  zap:         ["M13 2L3 14h9l-1 8 10-12h-9l1-8z"],
  shield:      ["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"],
  award:       ["circle:12,8,7", "M8.21 13.89L7 23l5-3 5 3-1.21-9.12"],
  logout:      ["M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4", "M16 17l5-5-5-5", "M21 12H9"],
  arrowLeft:   ["M19 12H5", "M12 19l-7-7 7-7"],
  arrowRight:  ["M5 12h14", "M12 5l7 7-7 7"],
  arrowUp:     ["M12 19V5", "M5 12l7-7 7 7"],
  chevronLeft: ["M15 18l-6-6 6-6"],
  chevronRight:["M9 18l6-6-6-6"],
  chevronDown: ["M6 9l6 6 6-6"],
  list:        ["M8 6h13", "M8 12h13", "M8 18h13", "M3 6h.01", "M3 12h.01", "M3 18h.01"],
  layers:      ["M12 2L2 7l10 5 10-5-10-5z", "M2 17l10 5 10-5", "M2 12l10 5 10-5"],
  share:       ["circle:18,5,3", "circle:6,12,3", "circle:18,19,3", "M8.59 13.51l6.83 3.98", "M15.41 6.51l-6.82 3.98"],
  sun:         ["circle:12,12,5", "M12 1v2", "M12 21v2", "M4.22 4.22l1.42 1.42", "M18.36 18.36l1.42 1.42", "M1 12h2", "M21 12h2", "M4.22 19.78l1.42-1.42", "M18.36 5.64l1.42-1.42"],
  moon:        ["M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"],
  camera:      ["M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z", "circle:12,13,4"],
  image:       ["M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z", "circle:8.5,8.5,1.5", "M21 15l-5-5L5 21"],
  tool:        ["M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"],
  grid:        ["M3 3h7v7H3z", "M14 3h7v7h-7z", "M14 14h7v7h-7z", "M3 14h7v7H3z"],
  percent:     ["M19 5L5 19", "circle:6.5,6.5,2.5", "circle:17.5,17.5,2.5"],
  chart:       ["M18 20V10", "M12 20V4", "M6 20v-6"],
  activity:    ["M22 12h-4l-3 9L9 3l-3 9H2"],
};

export function Icon({ name, size = 16, stroke = "currentColor", strokeWidth = 1.8, className = "", fill = "none" }) {
  const raw = PATHS[name];
  if (!raw) return null;

  const paths = [];
  const circles = [];
  const rects = [];

  (Array.isArray(raw) ? raw : [raw]).forEach(p => {
    if (p.startsWith("circle:")) {
      const [cx, cy, r] = p.slice(7).split(",").map(Number);
      circles.push({ cx, cy, r });
    } else if (p.startsWith("rect:")) {
      const [x, y, w, h, rx] = p.slice(5).split(",").map(Number);
      rects.push({ x, y, w, h, rx });
    } else {
      paths.push(p);
    }
  });

  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      fill={fill} stroke={stroke}
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className}
    >
      {paths.map((d, i) => <path key={i} d={d} />)}
      {circles.map((c, i) => <circle key={`c${i}`} cx={c.cx} cy={c.cy} r={c.r} />)}
      {rects.map((r, i) => <rect key={`r${i}`} x={r.x} y={r.y} width={r.w} height={r.h} rx={r.rx} />)}
    </svg>
  );
}

export default Icon;
